<template>
  <component
    :is="isObtained ? 'div' : 'router-link'"
    v-bind="isObtained ? {} : { to: `/permits/${permit.id}?fid=${permit.foreigner_id}` }"
    tabindex="0"
    class=" tw-block tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-3xl tw-p-10 tw-transition"
    :class="[
      isObtained ? 'tw-flex tw-justify-between tw-items-center' : 'tw-cursor-pointer hover:tw-shadow'
    ]"
  >
    <div class="tw-flex tw-flex-col">
      <div class="tw-flex tw-justify-between tw-w-full">
        <h3
          class="tw-leading-6 tw-tracking-wide"
          :class="isObtained ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : 'tw-text-dark dark:tw-text-dm-dark'"
        >
          {{ permit.permit_type_name }}
        </h3>
        <i-badge
          v-if="!isObtained && permit?.permit_document_missing_count !== 0"
          type="primary"
          is-circle
          size="big"
        >
          {{ permit.permit_document_missing_count }}
        </i-badge>
      </div>

      <div
        v-if="isObtained"
        class="tw-inline-block tw-text-base tw-tracking-wider tw-leading-5 tw-text-gray-dark dark:tw-text-dm-gray-dark tw-mt-2"
      >
        <span class="tw-font-medium  tw-mr-3">
          {{ permit.reference_number }}
        </span>
        <span>
          {{ permit.issue_date }}
          &ndash;
          {{ permit.expire_date }}
        </span>
      </div>
    </div>
    <template v-if="!isObtained">
      <div class="tw-text-xl tw-leading-6 tw-tracking-wide tw-text-gray-dark dark:tw-text-dm-gray-dark tw-font-bold">
        {{ permit.current_status_type_name }}
      </div>
      <i-step-progress
        :steps="permit.status_count"
        :active-step="permit.current_status_human_order"
        class="tw-mt-4"
      />
    </template>

    <div v-if="permit.final_document_url">
      <i-button
        is-icon
        @click.stop="downloadFileByUrlV2(permit.final_document_url, 'obtained_document.pdf', $axios)"
      >
        <icon-download />
      </i-button>
    </div>
  </component>
</template>

<script>
import { downloadFileByUrlV2 } from '@/helpers';

export default {
  props: {
    permit: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isObtained() {
      return this.permit.permit_status === 30;
    },
  },

  methods: {
    downloadFileByUrlV2,
  },
};
</script>
